import { numify } from "numify";

export const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
};
export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};

export const formatCurrency2 = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
};


export const formatCurrency3 = (amount) => {
    //console.log(amount);
    if( amount>1000000 ) amount = numify(amount);
    else if( amount>1000 ) amount = numify2(amount);
    //console.log(amount);
    //233333.33333333337

    //return amount;
    try{
        return amount.toFixed(0);
    }
    catch{
        return amount;
    }
};

const numify2 = (amount) => {
  if (amount >= 1_000_000) {
    return Math.floor(amount / 1_000_000) + "M";
  } else if (amount >= 1_000) {
    return Math.floor(amount / 1_000) + "k";
  }
  return amount.toString();
};